module.exports=function(scope){ return `<!-- idScan match successful -->
{
    "meta": {
        "ok": true,
        "code": 200,
        "mode": "dev",
        "message": "The ID Check was processed successfully."
    },
    "data": {
      "digitalSpoofStatus": 0,
      "errorMessageFromZoomServer": null,
      "errorStatusFromZoomServer": 0,
      "faceMapAgeEstimateGroup": 4,
      "fullIDStatus": 0,
      "glasses": true
      "idScanAgeEstimateGroup": 4
      "isLowQuality": false
      "isReplayFaceMap": false
      "livenessStatus": 0
      "matchLevel": 7
    }
}

<!-- idScan match unsuccessful -->
{
    "meta": {
        "ok": true,
        "code": 200,
        "mode": "dev",
        "message": "The ID Check was processed successfully."
    },
    "data": {
      "digitalSpoofStatus": 0,
      "errorMessageFromZoomServer": null,
      "errorStatusFromZoomServer": 0,
      "faceMapAgeEstimateGroup": 4,
      "fullIDStatus": 0,
      "glasses": true
      "idScanAgeEstimateGroup": 4
      "isLowQuality": false
      "isReplayFaceMap": false
      "livenessStatus": 0
      "matchLevel": 0
    }
}

<!-- idScan match unsuccessful for full ID was not captured in the image -->
{
    "meta": {
        "ok": true,
        "code": 200,
        "mode": "dev",
        "message": "The ID Check was processed successfully."
    },
    "data": {
        "digitalSpoofStatus": 1,
        "errorMessageFromZoomServer": null,
        "errorStatusFromZoomServer": 0,
        "faceMapAgeEstimateGroup": 4,
        "fullIDStatus": 1,
        "glasses": false,
        "idScanAgeEstimateGroup": 4,
        "isLowQuality": false,
        "isReplayFaceMap": false,
        "livenessStatus": 0,
        "matchLevel": 0
    }
}

<!-- NOTE: Server REST API provides additional properties for this end point. -->
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/response/success/id-check.json.tpl